import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { ModalDirective } from 'ngx-bootstrap';
import { of } from 'rxjs/internal/observable/of';
import { catchError, timeout } from 'rxjs/operators';
import { ConfigService } from 'src/app/services/config.service';
import * as Constants from 'src/app/utils/constants';
import { MULTILANGUAGE, REMAINING, SHOW_QRCODE, TIMEOUT } from 'src/app/utils/constants';
import { CheckExistQueueInput, GetInfomationCustomerModel, GetQueueBookingForTabletModel } from '../../models/queues-get.models';
import { Customer, ProductGroup } from '../../models/queues-response.models';
import { QueuesService } from '../../services/queues.service';

@Component({
    selector: 'app-component-transaction-queue-tablet',
    templateUrl: './transaction-queue-tablet.component.html',
    styleUrls: ['./transaction-queue-tablet.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TransactionQueueTabletComponent implements OnInit, OnDestroy {

    @ViewChild('warningModal', { static: true }) warningModal: ModalDirective;
    @ViewChild('strSearch', { static: false }) strSearch!: ElementRef;

    lstgroup: ProductGroup[];
    model: GetInfomationCustomerModel = { FilterText: "", IsCorp: false };
    strFilter: string = "";
    queuestt: string;
    orgCode: string;
    titile: string;
    isSpinning: boolean;
    isValid: boolean = true;
    customerName: string = "";
    branchName: string;
    branchNameEn: string;
    productName: string;
    isZaloChannel: boolean = true;
    isEwallet: boolean = false;
    customer: Customer;
    cuscde: string;
    splitTypeCus = false;
    isPiority: boolean = false;
    titleAlert: string;
    contentAlert: string;
    remaningConfig: number = 0;
    remainingTime: number = 0;
    intervalId: any; // Store the interval reference
    isCompleteQueue: boolean = false;
    surveyQr: string;
    oldValue: string;
    isFullScreening: boolean = false;
    isEnglish: boolean = false;
    isBookingPiority: boolean = false;
    isShowKeyBoard: boolean = false;
    isMultiLanguage: boolean;
    isShowQRCode: boolean;
    configTimeout: number;
    step1: boolean = true;
    step2: boolean = false;
    step3: boolean = false;
    productGroupSelected: number = 0;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private queuesService: QueuesService,
        private configSevice: ConfigService,
        private cdref: ChangeDetectorRef) {
        this.remaningConfig = this.configSevice.get(REMAINING);
        this.isMultiLanguage = this.configSevice.get(MULTILANGUAGE);
        this.isShowQRCode = this.configSevice.get(SHOW_QRCODE);
        this.configTimeout = this.configSevice.get(TIMEOUT);
        this.route.queryParams.subscribe(params => {
            this.isSpinning = true;
            let org = params["orgCode"];
            if (org) {
                this.orgCode = org;
                this.queuesService.getBranchInfo(this.orgCode)
                    .pipe(
                        timeout(this.configTimeout),
                        catchError(err => {
                            if (err.name === "TimeoutError") {
                                this.titleAlert = this.alertUnavailableHeader;
                                this.contentAlert = this.alertUnavailableContent;
                                this.isSpinning = false;
                                this.startCountdown(this.remaningConfig, false);
                                this.goHomeScreen();
                                this.warningModal.show();
                                return of(null);
                            }
                            throw err;
                        })
                    )
                    .subscribe(res => {
                        if (res) {
                            this.surveyQr = res["surveyQR"];
                            this.branchName = res["nameVN"];
                            this.branchNameEn = res["nameEn"];
                        } else if (!res.result.isSuccess && res.result.response == "RB99") {
                            this.titleAlert = this.alertUnavailableHeader;
                            this.contentAlert = this.alertUnavailableContent;
                            this.isSpinning = false;
                            this.startCountdown(this.remaningConfig, false);
                            this.goHomeScreen();
                            this.warningModal.show();
                        }
                    });
            }
            else
                return this.router.navigate(["page-not-found"]);
        });
    }

    @HostListener('document:click', ['$event'])
    @HostListener('document:touchend', ['$event'])
    handleOutsideClick(event: Event) {
        if (this.isSpinning) return;

        const clickedElement = event.target as HTMLElement;
        if (this.step2 && this.isShowKeyBoard) {
            if (this.strSearch && !this.strSearch.nativeElement.contains(clickedElement) && this.strFilter) {
                if (this.isValidVietnamPhone(this.strFilter) || this.isValidVietnamLegalId(this.strFilter)) {
                    if (!this.strSearch.nativeElement.contains(event.target)) {
                        if (this.strSearch && this.strFilter && (this.customerName == "" || this.oldValue != this.strFilter)) {
                            this.oldValue = this.strFilter;
                            this.inquireCustomer();
                        }
                    }
                }
                else {
                    if (!this.warningModal.isShown) {
                        this.titleAlert = this.alertInvalidInfoHeader;
                        this.contentAlert = this.alertInvalidInfoContent;
                        this.isValid = false;
                        this.isSpinning = false;
                        this.startCountdown(this.remaningConfig, false);
                        this.warningModal.show();
                    }
                }
                this.isShowKeyBoard = false;
                return;
            } else if (this.strSearch && !this.strSearch.nativeElement.contains(clickedElement)) {
                this.isShowKeyBoard = false;
                return;
            }
        }
    }

    onKeyBoardPress(value) {
        if (this.isSpinning) return;

        const input = this.strSearch.nativeElement as HTMLInputElement;
        const start = input.selectionStart || 0;
        const end = input.selectionEnd || 0;
        let newposition;
        if (value === "delete") {
            this.strFilter = this.strFilter.slice(0, start - 1) + this.strFilter.slice(end);
            input.selectionStart = input.selectionEnd = start - 1;
            newposition = start - 1;
        }
        else if (value === "enter") {
            this.isSpinning = true;
            if (this.strFilter == '') {
                this.titleAlert = this.alertInvalidInfoHeader;
                this.contentAlert = this.alertInvalidInfoContent;
                this.isValid = false;
                this.isSpinning = false;
                this.startCountdown(this.remaningConfig, false);
                this.isShowKeyBoard = false;
                this.warningModal.show();
                return;
            } else {
                this.inquireCustomer();
            }
        }
        else {
            this.strFilter = this.strFilter.slice(0, start) + value + this.strFilter.slice(end);
            input.selectionStart = input.selectionEnd = start + 1;
            newposition = start + 1;
        }

        setTimeout(() => {
            input.focus();
            input.setSelectionRange(newposition, newposition);
        }, 0)
    }

    changeLanguage(event) {
        this.isEnglish = event;
    }

    onSearchFocus() {
        this.isShowKeyBoard = true;
    }

    toggleFullscreen() {
        if (document.fullscreenElement) {
            // Currently in fullscreen — exit
            this.exitFullscreen();
        } else {
            // Not in fullscreen — enter
            this.enterFullscreen();
        }
    }

    enterFullscreen() {
        const elem = document.documentElement;
        if (elem.requestFullscreen) {
            elem.requestFullscreen();
            this.isFullScreening = true;
        } else if ((elem as any).webkitRequestFullscreen) {
            // Safari
            (elem as any).webkitRequestFullscreen();
            this.isFullScreening = true;
        } else if ((elem as any).msRequestFullscreen) {
            // IE11
            (elem as any).msRequestFullscreen();
            this.isFullScreening = true;
        }
    }

    exitFullscreen() {
        if (document.exitFullscreen) {
            document.exitFullscreen().catch(err => {
                console.error('Error attempting to exit fullscreen:', err);
            });
        }
    }

    checkUpdateFilter() {
        this.oldValue = this.strFilter;
    }

    ngOnInit(): void {
        this.remainingTime = 0;
        this.getProductGroups();
        this.warningModal.onHide.subscribe(() => {
            this.strSearch.nativeElement.focus()
            this.reset(false);
        });
    }

    ngAfterContentChecked() {
        this.cdref.detectChanges();
    }

    // Cleanup the interval when the component is destroyed
    ngOnDestroy(): void {
        this.stopCountdown();
    }

    getProductGroups() {
        this.isSpinning = true;
        this.queuesService.getProductGroups(this.orgCode)
            .pipe(
                timeout(this.configTimeout),
                catchError(err => {
                    if (err.name === "TimeoutError") {
                        this.titleAlert = this.alertUnavailableHeader;
                        this.contentAlert = this.alertUnavailableContent;
                        this.isSpinning = false;
                        this.startCountdown(this.remaningConfig, false);
                        this.goHomeScreen();
                        this.warningModal.show();
                        return of(null);
                    }
                    throw err;
                })
            )
            .subscribe(response => {
                if (response) {
                    this.lstgroup = response.filter(x => x.isActive);
                    let groupType = _.uniqWith(this.lstgroup.filter(x => x.groupName), 'groupName');
                    this.splitTypeCus = groupType.length > 1;
                    this.isSpinning = false;
                } else if (!response.result.isSuccess && response.result.response == "RB99") {
                    this.titleAlert = this.alertUnavailableHeader;
                    this.contentAlert = this.alertUnavailableContent;
                    this.isSpinning = false;
                    this.startCountdown(this.remaningConfig, false);
                    this.goHomeScreen();
                    this.warningModal.show();
                } else {
                    return this.router.navigate(["page-not-found"]);
                }
            }, error => {
                return this.router.navigate(["page-not-found"]);
            });
    }

    closeModalWarning(iscomplete: boolean) {
        this.stopCountdown()
        this.focusAfterShowModal()
    }

    focusAfterShowModal() {
        const input = this.strSearch.nativeElement as HTMLInputElement;
        const end = input.value.length;
        input.setSelectionRange(end, end);
    }

    reset(iscomplete: boolean) {
        this.remainingTime = 0;
        if (iscomplete) {
            this.customerName = "";
            this.productName = "";
            this.queuestt = "";
            this.strFilter = "";
            this.isPiority = false;
            this.customer = new Customer();
            this.isBookingPiority = false;
            this.step3 = false;
            this.step2 = false;
            this.step1 = true;
        } else if (this.step2) {
            if (this.remainingTime == 0 && this.strFilter == '' && this.isValid) {
                this.step3 = false;
                this.step2 = false;
                this.step1 = true;
            }
            else {
                this.isValid = true;
                this.startCountdown(this.remaningConfig, false);
            }
        }
    }

    backtoHome() {
        this.strFilter = "";
        this.productGroupSelected = 0;
        this.step3 = false;
        this.step2 = false;
        this.step1 = true;
    }

    selectedService(groupid: number) {
        this.step1 = false;
        this.step2 = true;
        this.productGroupSelected = groupid;
        this.startCountdown(this.remaningConfig, false);
    }

    getQueueWithProductSelected() {
        let checkBooking = new GetQueueBookingForTabletModel();
        checkBooking.Code = this.strFilter;
        checkBooking.SearchByIdentity = true;
        checkBooking.CompanyCode = this.orgCode;
        this.queuesService.getQueueBooking(checkBooking)
            .pipe(
                timeout(this.configTimeout),
                catchError(err => {
                    if (err.name === "TimeoutError") {
                        this.titleAlert = this.alertUnavailableHeader;
                        this.contentAlert = this.alertUnavailableContent;
                        this.isSpinning = false;
                        this.startCountdown(this.remaningConfig, false);
                        this.goHomeScreen();
                        this.warningModal.show();
                        return of(null);
                    }
                    throw err;
                })
            )
            .subscribe(res => {
                if (res.result.isSuccess) {
                    if (res.result.value.result) {
                        if (res.result.value.result.isPriority && res.result.value.result.bookingId > 0) {
                            this.customer.ProductGroupId = res.result.value.result.productGroupId
                            this.isBookingPiority = res.result.value.result.isPriority
                        }
                    }

                    this.checkExistQueue(this.customer);
                    let productSelected = this.lstgroup.filter(x => x.isActive && x.id == this.productGroupSelected);
                    if (productSelected.length > 0)
                        this.productName = this.isEnglish ? productSelected[0].nameEn : productSelected[0].name;
                } else if (!res.result.isSuccess && res.result.response == "RB99") {
                    this.titleAlert = this.alertUnavailableHeader;
                    this.contentAlert = this.alertUnavailableContent;
                    this.isSpinning = false;
                    this.startCountdown(this.remaningConfig, false);
                    this.goHomeScreen();
                    this.warningModal.show();
                }
            })
    }

    checkExistQueue(data: Customer) {
        let modelInfoQueue = new CheckExistQueueInput();
        modelInfoQueue.OrgCode = this.orgCode;
        modelInfoQueue.FullName = this.customerName;
        modelInfoQueue.NationalId = data.nationalId;
        modelInfoQueue.CustomerCode = data.customerCode;
        modelInfoQueue.CustomerCode = data.customerCode;
        data.branchCode = this.orgCode;
        data.phone = data.phone;
        data.fullName = this.customerName;
        data.isZalo = this.isZaloChannel;

        this.queuesService.checkExistQueue(modelInfoQueue)
            .pipe(
                timeout(this.configTimeout),
                catchError(err => {
                    if (err.name === "TimeoutError") {
                        this.titleAlert = this.alertUnavailableHeader;
                        this.contentAlert = this.alertUnavailableContent;
                        this.isSpinning = false;
                        this.startCountdown(this.remaningConfig, false);
                        this.goHomeScreen();
                        this.warningModal.show();
                        return of(null);
                    }
                    throw err;
                })
            )
            .subscribe(res => {
                if (res.result.isSuccess) {
                    if (!res.result.value.result || res.result.value.result.queueNumber == "") {
                        data.isPriority = !this.customer.isPriority && !this.isPiority && !this.isBookingPiority ? false : true;
                        this.queuesService.createNewQueueForTablet(data)
                            .pipe(
                                timeout(this.configTimeout),
                                catchError(err => {
                                    if (err.name === "TimeoutError") {
                                        this.titleAlert = this.alertUnavailableHeader;
                                        this.contentAlert = this.alertUnavailableContent;
                                        this.isSpinning = false;
                                        this.startCountdown(this.remaningConfig, false);
                                        this.goHomeScreen();
                                        this.warningModal.show();
                                        return of(null);
                                    }
                                    throw err;
                                })
                            )
                            .subscribe(response => {
                                if (response.result.isSuccess) {
                                    this.queuestt = response.result.value.result;
                                    this.isSpinning = false;
                                    this.startCountdown(this.remaningConfig, true);
                                    this.step1 = false;
                                    this.step2 = false;
                                    this.step3 = true;
                                }
                                else if (response.result.error == Constants.IP_BLOCK_CODE) {
                                    this.titleAlert = "Cảnh báo";
                                    this.contentAlert = "Vui lòng thử lại sau " + (response.result.messageError == Constants.IP_BLOCK_MESSAGE ? "5 phút!" : "ít phút!");
                                    this.isSpinning = false;
                                    this.startCountdown(this.remaningConfig, true);
                                    this.goHomeScreen();
                                    this.warningModal.show();
                                }
                                else {
                                    return this.router.navigate(["page-not-found"]);
                                }
                            }, error => {
                                return this.router.navigate(["page-not-found"]);
                            })
                    }
                    else {
                        this.queuestt = res.result.value.result.queueNumber;
                        this.isPiority = this.queuestt.substring(0, 1) == "1" ? true : false;
                        let productSelected = this.lstgroup.filter(x => x.isActive && x.id == res.result.value.result.productGroupId);
                        if (productSelected)
                            this.productName = this.isEnglish ? productSelected[0].nameEn : productSelected[0].name;

                        this.isSpinning = false;
                        this.startCountdown(this.remaningConfig, true);
                        this.step1 = false;
                        this.step2 = false;
                        this.step3 = true;
                    }
                } else if (!res.result.isSuccess && res.result.response == "RB99") {
                    this.titleAlert = this.alertUnavailableHeader;
                    this.contentAlert = this.alertUnavailableContent;
                    this.isSpinning = false;
                    this.startCountdown(this.remaningConfig, false);
                    this.goHomeScreen();
                    this.warningModal.show();
                } else {
                    return this.router.navigate(["page-not-found"]);
                }
            }, error => {
                return this.router.navigate(["page-not-found"]);
            });
    }

    padWithLeadingZeros(num, totalLength) {
        return String(num).padStart(totalLength, '0');
    }

    isValidVietnamPhone(phone: string): boolean {
        const phoneRegex = /^(?:\+84|0)(3[2-9]|5[689]|7[06-9]|8[1-9]|9[0-9])\d{7}$/;
        return phoneRegex.test(phone);
    }

    isValidVietnamLegalId(id: string): boolean {
        const legalIdRegex = /^(\d{12})$/;
        return legalIdRegex.test(id);
    }

    inquireCustomer() {
        this.isSpinning = true;
        this.isShowKeyBoard = false;

        if (!this.customer)
            this.customer = new Customer();

        if (this.isValidVietnamPhone(this.strFilter)) {
            this.queuesService.getCustomerByPhone({ IsCorp: false, FilterText: this.strFilter })
                .pipe(
                    timeout(this.configTimeout),
                    catchError(err => {
                        if (err.name === "TimeoutError") {
                            this.titleAlert = this.alertUnavailableHeader;
                            this.contentAlert = this.alertUnavailableContent;
                            this.isSpinning = false;
                            this.startCountdown(this.remaningConfig, false);
                            this.goHomeScreen();
                            this.warningModal.show();
                            return of(null);
                        }
                    })
                )
                .subscribe(response => {
                    if (response.result.isSuccess) {
                        this.customerName = response.result.value.result.fullName == '' ? this.strFilter : response.result.value.result.fullName.toUpperCase().trim().replace(/ +(?= )/g, "");
                        this.customer = response.result.value.result;
                        this.customer.orgCode = this.orgCode;
                        this.customer.productGroupId = this.productGroupSelected;
                        this.isZaloChannel = !response.result.value.result.ewallName;
                        this.isEwallet = !!response.result.value.result.ewallName;
                        if (response.result.value.result.nationalId == null || response.result.value.result.nationalId == '')
                            response.result.value.result.nationalId = this.strFilter;

                        this.isShowKeyBoard = false;
                        this.getQueueWithProductSelected();
                    } else if (!response.result.isSuccess && response.result.response == "RB99") {
                        this.titleAlert = this.alertUnavailableHeader;
                        this.contentAlert = this.alertUnavailableContent;
                        this.isSpinning = false;
                        this.startCountdown(this.remaningConfig, false);
                        this.goHomeScreen();
                        this.warningModal.show();
                    }
                });
        } else if (this.isValidVietnamLegalId(this.strFilter)) {
            this.queuesService.getCustomerByDoc({ IsCorp: false, FilterText: this.strFilter })
                .pipe(
                    timeout(this.configTimeout),
                    catchError(err => {
                        if (err.name === "TimeoutError") {
                            this.titleAlert = this.alertUnavailableHeader;
                            this.contentAlert = this.alertUnavailableContent;
                            this.isSpinning = false;
                            this.startCountdown(this.remaningConfig, false);
                            this.goHomeScreen();
                            this.warningModal.show();
                            return of(null);
                        }
                    })
                )
                .subscribe(response => {
                    if (response.result.isSuccess) {
                        this.customerName = response.result.value.result.fullName == '' ? this.strFilter : response.result.value.result.fullName.toUpperCase().trim().replace(/ +(?= )/g, "");
                        this.customer = response.result.value.result;
                        this.customer.orgCode = this.orgCode;
                        this.customer.productGroupId = this.productGroupSelected;
                        this.isZaloChannel = !response.result.value.result.ewallName;
                        this.isEwallet = !!response.result.value.result.ewallName;
                        if (response.result.value.result.nationalId == null || response.result.value.result.nationalId == '')
                            response.result.value.result.nationalId = this.strFilter;

                        this.isShowKeyBoard = false;
                        this.getQueueWithProductSelected();
                    } else if (!response.result.isSuccess && response.result.response == "RB99") {
                        this.titleAlert = this.alertUnavailableHeader;
                        this.contentAlert = this.alertUnavailableContent;
                        this.isSpinning = false;
                        this.startCountdown(this.remaningConfig, false);
                        this.goHomeScreen();
                        this.warningModal.show();
                    }
                });
        } else if (!this.warningModal.isShown) {
            this.titleAlert = this.alertInvalidInfoHeader;
            this.contentAlert = this.alertInvalidInfoContent;
            this.isValid = false;
            this.isSpinning = false;
            this.startCountdown(this.remaningConfig, false);
            this.isShowKeyBoard = false;
            this.warningModal.show();
        }
    }

    // Method to start the countdown
    startCountdown(seconds: number, iscomplete: boolean) {
        this.remainingTime = seconds;
        if (this.intervalId) {
            clearInterval(this.intervalId); // Stop the timer when it reaches zero
            this.intervalId = null;
        }

        this.intervalId = setInterval(() => {
            if (this.remainingTime > 0) {
                this.remainingTime--;
            } else {
                this.stopCountdown();
                this.reset(iscomplete);
            }
        }, 1000);
    }

    stopCountdown() {
        if (this.intervalId) {
            clearInterval(this.intervalId); // Stop the timer when it reaches zero
            this.intervalId = null;
        }

        if (this.warningModal.isShown) {
            this.warningModal.hide();
        }
    }

    goHomeScreen() {
        this.step1 = true;
        this.step2 = false;
        this.step3 = false;
    }

    //vi/en content
    get welcomeContent(): string {
        return this.isEnglish ? "WARM GREETINGS!" : "KÍNH CHÀO QUÝ KHÁCH";
    }

    get chooseProduct(): string {
        return this.isEnglish ? "Please select the product or service you need support" : "Vui lòng chọn sản phẩm/dịch vụ cần hỗ trợ";
    }

    get inputPlaceholder(): string {
        return this.isEnglish ? "Please enter phone number or ID card number to get the queue ticket" : "Mời nhập số điện thoại hoặc số căn cước để lấy số thứ tự";
    }

    get priorityCustomer(): string {
        return this.isEnglish ? "Priority Customer" : "Khách hàng ưu tiên";
    }

    get bankRegulations(): string {
        return this.isEnglish ? "Refer To Bank Regulations" : "Tham khảo quy định Ngân Hàng";
    }

    get ratingService(): string {
        return this.isEnglish ? "Evaluate Service Quality" : "Đánh giá chất lượng dịch vụ";
    }

    get close(): string {
        return this.isEnglish ? "Close" : "Đóng";
    }

    get service(): string {
        return this.isEnglish ? "Type of service" : "Dịch vụ";
    }

    get customerEn(): string {
        return this.isEnglish ? "Customer" : "Khách hàng";
    }

    get offical(): string {
        return this.isEnglish ? "Branch" : "CN/PGD";
    }

    get queueNumber(): string {
        return this.isEnglish ? "Your Queue Number" : "Số thứ tự của Quý khách";
    }

    get notificationOnPhone(): string {
        return this.isEnglish ? "Please take note and check the notification in your app" : "Vui lòng ghi nhận và kiểm tra thông báo trên ứng dụng"
    }

    get keyboarDelete(): string {
        return this.isEnglish ? "DELETE" : "XÓA"
    }

    get keyboarComplete(): string {
        return this.isEnglish ? "COMPLETE" : "HOÀN TẤT"
    }

    get getBackToHome(): string {
        return this.isEnglish ? "Back to home " : "Về trang chủ "
    }

    get alertInvalidInfoHeader(): string {
        return this.isEnglish ? "Invalid information" : "Thông tin Quý khách nhập chưa đúng"
    }

    get alertInvalidInfoContent(): string {
        return this.isEnglish ? "Please enter phone number or ID card number" : "Vui lòng nhập số điện thoại/thẻ căn cước"
    }

    get alertUnavailableHeader(): string {
        return this.isEnglish ? "Our system is temporarily unavailable" : "Hệ thống chưa sẵn sàng phục vụ!"
    }

    get alertUnavailableContent(): string {
        return this.isEnglish ? "Please try again later or kindly contact our staff for further assistance." : "Quý khách vui lòng thử lại hoặc liên hệ Nhân viên để được hỗ trợ."
    }

    get loadingSpinner(): string {
        return this.isEnglish ? "Thank you for you patience. We'll be with you shortly" : "Quý khách vui lòng chờ trong giây lát!";
    }
}